<template>
  <pt-modal
    ref="responseModal"
    :close-on-outside-click="false"
    size="medium"
  >
    <!-- showing api response -->
    <div
      v-if="response"
      slot="modal-body"
      class="flex flex-col items-center"
    >
      <img
        v-if="response.data.success"
        src="@assets/images/ic_circle_checked.svg"
        alt="success alert"
      />
      <img
        v-else
        src="@assets/images/ic_alert_solid.svg"
        alt="error alert"
      />
      <div class="font-bold text-lg text-black mb-1">
        {{ getTitle }}
      </div>
      <div class="font-medium text-base text-center text-grey-dark mb-6">
        {{ getBody }}
      </div>
      <overlapped-holidays
        v-if="isOverlappedHolidays"
        :data="response.data.data.overlapped_holidays"
        class="mb-4"
      />
      <pt-button
        variant="secondary-outline"
        size="sm"
        class="w-1/2"
        @action="closeModal"
      >
        Okay
      </pt-button>
    </div>
    <div
      v-else-if="isDelete || isConfirm"
      slot="modal-body"
      class="flex flex-col items-center"
    >
      <div class="flex flex-col items-center">
        <img
          v-if="isDelete"
          src="@assets/images/ic_delete.svg"
          alt="delete"
        />
        <img
          v-else
          src="@assets/images/ic_confirm_solid.svg"
          alt="delete"
        />
        <div class="font-bold text-lg text-black mb-1">
          {{ isDelete ? 'Delete' : 'Confirmation' }}
        </div>
        <div class="font-medium text-base text-center text-grey-dark mb-6">
          {{ isDelete ? 'Confirm if you want to delete this holiday request.' : 'Are you sure you want to submit your holiday request?' }}
        </div>
      </div>
      <div class="flex flex-row">
        <pt-button
          variant="primary-outline"
          size="sm"
          class="w-1/2 mr-2"
          @action="confirm"
        >
          Yes
        </pt-button>
        <pt-button
          variant="secondary-outline"
          size="sm"
          class="w-1/2"
          @action="cancel"
        >
          Cancel
        </pt-button>
      </div>
    </div>
    <div
      v-else-if="isLearnMore"
      slot="modal-body"
      class="flex flex-col items-center"
    >
      <img src="@assets/images/ic_confirm_solid.svg" alt="confirm" />
      <div class="font-bold text-lg text-center text-black mb-1 ">
        Learn More about holiday hours
      </div>
      <div class="w-full flex flex-col sm:w-full md:w-2/3">
        <div class="flex flex-row mb-2">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">Title</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">Reasoning behind the holiday Holiday </div>
        </div>
        <div class="flex flex-row mb-2">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">Holiday Starts</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">The date when your holiday begins </div>
        </div>
        <div class="flex flex-row mb-2">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">Holiday Ends</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">The date when your holiday ends </div>
        </div>
        <div class="flex flex-row mb-2">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">Full Day Closed</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">If your restaurant is closed throughout the day </div>
        </div>
        <div class="flex flex-row mb-2">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">Start Time (Optional)</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">Restaurant opening time during your holiday </div>
        </div>
        <div class="flex flex-row">
          <div class="w-1/3 rounded bg-grey-light font-semibold break-words p-2 mr-1">End Time (Optional)</div>
          <div class="w-2/3 border rounded border-grey-light p-2 ml-1 font-semibold text-grey-darker">Restaurant closing time during your holiday </div>
        </div>
      </div>
      <pt-button
        variant="secondary-outline"
        size="sm"
        class="w-1/2 mt-4"
        @action="closeModal"
      >
        Okay
      </pt-button>
    </div>
  </pt-modal>
</template>

<script>
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { PtButton } from '@pathao/ui-components';
import { RESPONSE_MODAL_DATA } from '@constants';
import OverlappedHolidays from '@components/custom/OverlappedHolidays.vue';
export default {
  name: 'ResponseModal',
  components: {
    PtModal,
    PtButton,
    OverlappedHolidays,
  },
  props: {
    response: {
      type: Object,
      default: null,
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    isLearnMore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getTitle() {
      return this.response.data.success ? 'Changes Saved' : this.response.data.code && RESPONSE_MODAL_DATA[this.response.data.code].title ? RESPONSE_MODAL_DATA[this.response.data.code].title : 'Error';
    },
    getBody() {
      return this.response.data.success ? 'Your Business Hours have been set' : this.response.data.code && RESPONSE_MODAL_DATA[this.response.data.code].body ? RESPONSE_MODAL_DATA[this.response.data.code].body : this.response.data.message;
    },
    isOverlappedHolidays() {
      return this.response.data.code === 'FOOD_3003';
    },
  },
  methods: {
    showModal() {
      this.$refs.responseModal.showModal();
    },
    closeModal() {
      this.$refs.responseModal.closeModal();
      this.$emit('onCloseModal');
    },
    confirm() {
      this.$refs.responseModal.closeModal();
      this.$emit('onConfirm');
      this.$emit('onCloseModal');
    },
    cancel() {
      this.$refs.responseModal.closeModal();
      this.$emit('onCancel');
      this.$emit('onCloseModal');
    },
  },
};
</script>
